import { api } from './api';

export interface ConstitutionVersionSummary {
  id: string;
  version: number;
  summary: string | null;
  effectiveFrom: string;
  ratifiedAt: string;
  ratifiedBy: { firstName: string; lastName: string } | null;
}

export interface ConstitutionData {
  draftHtml: string;
  currentVersion: number;
  versions: ConstitutionVersionSummary[];
  current: { id: string; version: number; bodyHtml: string; effectiveFrom: string; ratifiedAt: string } | null;
}

export interface ConstitutionVersionFull {
  id: string;
  version: number;
  bodyHtml: string;
  summary: string | null;
  effectiveFrom: string;
  ratifiedAt: string;
  ratifiedBy: { firstName: string; lastName: string } | null;
}

export async function fetchConstitution(): Promise<ConstitutionData> {
  return (await api.get('/constitution')).data.data as ConstitutionData;
}

export async function saveConstitutionDraft(draftHtml: string): Promise<void> {
  await api.put('/constitution/draft', { draftHtml });
}

export async function ratifyConstitution(input: { effectiveFrom?: string; summary?: string }): Promise<{ version: number }> {
  return (await api.post('/constitution/ratify', input)).data.data as { version: number };
}

export async function fetchConstitutionVersion(versionId: string): Promise<ConstitutionVersionFull> {
  return (await api.get(`/constitution/versions/${versionId}`)).data.data as ConstitutionVersionFull;
}
